import { I18nComponente } from "@/types/gerais"

export const NovoTipoAtividadei18n: I18nComponente = {
  "pt-BR": {
    criarTipoDeAtividade: "criar tipo de atividade",
    editarTipoDeAtividade: "editar tipo de atividade",
    atividades: "atividades",
    salvar: "salvar",
    cancelar: "cancelar",
    voltarEditar: "voltar e editar",
    simCancelar: "sim, cancelar",
    cancelarEdicaoDoTipoDeAtividade: "Cancelar edição do tipo de atividade?",
    aoCancelarVocePerderaTodasAsInformacoesNaoSalvas: "Ao cancelar você perderá todas as informações não salvas.",
    naoFoiPossivelSalvar: "não foi possível salvar",
    tipoDeAtividadeCriado: "tipo de atividade criado",
    tipoDeAtividadeAtualizado: "tipo de atividade atualizado",
    naoFoiPossivelCadastrarNovoTipoDeAtividade: "não foi possível cadastrar novo tipo de atividade",
    ocorreuUmErro: "ocorreu um erro",
    preenchaOsCamposCorretamente: "preencha os campos corretamente",
    camposInvalidos: "Campos inválidos",
    atributosEsperados: "atributos esperados",
    atividadeNaoPossuiAtributos: "atividade não possui atributos",
    adicionarAtributo: "adicionar atributo",
    naoFoiPossivelRecuperarAtributos: "não foi possível recuperar atributos",
  },
  "es-CO": {
    criarTipoDeAtividade: "añadir tipo de actividad",
    editarTipoDeAtividade: "editar tipo de actividad",
    atividades: "actividades",
    salvar: "guardar",
    cancelar: "cancelar",
    voltarEditar: "volver y editar",
    simCancelar: "sí, cancelar",
    cancelarEdicaoDoTipoDeAtividade: "¿Cancelar edición del tipo de actividad?",
    aoCancelarVocePerderaTodasAsInformacoesNaoSalvas: "Al cancelar perderás toda la información no guardada.",
    naoFoiPossivelSalvar: "no se pudo guardar",
    tipoDeAtividadeCriado: "tipo de actividad creado",
    tipoDeAtividadeAtualizado: "tipo de actividad actualizado",
    naoFoiPossivelCadastrarNovoTipoDeAtividade: "no se pudo registrar nuevo tipo de actividad",
    ocorreuUmErro: "ocurrió un error",
    preenchaOsCamposCorretamente: "rellene los campos correctamente",
    camposInvalidos: "Campos inválidos",
    atributosEsperados: "atributos esperados",
    atividadeNaoPossuiAtributos: "actividad no tiene atributos",
    adicionarAtributo: "añadir atributo",
    naoFoiPossivelRecuperarAtributos: "no se pudo recuperar atributos",
  }
}
